import React from 'react';
import {observer} from 'mobx-react';
import {t, withState} from 'shared/core';
import {auth, endpoints, types} from 'main/tools';
import {ExpenseRequest} from 'main/stores/expenses';
import {Layout} from 'shared/components';
import {InteractiveTable, DropdownFilter} from 'main/components';
import {FormattedMessage} from 'react-intl';
import ExpensesSubnav from '../../ExpensesSubnav';
import {MyExpensesState} from '../state';

const COLUMNS = [
  {
    header: 'expenses.my_expenses.Title',
    attribute: 'title',
    width: 3
  },
  {
    header: 'expenses.my_expenses.Total',
    attribute: 'amountView',
    width: 3,
    sortable: false
  },
  {
    header: 'expenses.my_expenses.Submitted',
    attribute: 'createdAtView',
    sortBy: 'createdAt',
    width: 3
  },
  {
    header: 'expenses.my_expenses.Status',
    render: model => <FormattedMessage id={`expenses.status.${model.status}`}/>,
    width: 2
  }
];

const statusOptions = () => {
  return [
    {id: 'pending', display: t('expenses.status.pending')},
    {id: 'approved', display: t('expenses.status.approved')},
    {id: 'rejected', display: t('expenses.status.rejected')}
  ];
};

const LOCALIZATION = {
  emptyState: 'expenses.my_expenses.No expense requests to display',
  interactive: {
    addModel: 'expenses.my_expenses.New Expense Request'
  },
  removeModal: {
    header: 'expenses.my_expenses.Remove expense request?',
    body: 'expenses.my_expenses.This will permanently delete the expense request and its receipts.'
  }
};

const MyExpensesContainer = observer(({scope, uiState}) => {
  return (
    <div>
      <ExpensesSubnav scope={scope} />
      <Layout>
        <InteractiveTable
          title={t('expenses.my_expenses.My Expenses')}
          columns={COLUMNS}
          saveStateToUrl
          localization={LOCALIZATION}
          initialFilter={{status: 'pending'}}
          showRoute={request => `/expense_requests/${request.id}/my_expenses`}
          editRoute='/expense_requests/:id/edit'
          onAdd={() => uiState.goToNewExpense()}
          onRemove={request => uiState.removeExpenseRequest(request)}
          proxy={{
            type: 'async',
            modelType: types.EXPENSES.REQUEST,
            model: ExpenseRequest,
            endpoint: endpoints.EXPENSES.REQUESTS.FOR_EMPLOYEE.with(auth.employee.id)
          }}
        >
          <DropdownFilter options={statusOptions()} attr='status'/>
        </InteractiveTable>
      </Layout>
    </div>
  );
});

export default withState(MyExpensesContainer, MyExpensesState);
